import Definition from "./Definition";

const Locality = (props) => {
    if(props.data !== null) {
        const locality = props.data;
        return (
            <>
                <h4>Locality Information</h4>
                <dl className={'row'}>
                    <Definition dt={'Number'} dd={locality.locality_no} />
                    <Definition dt={'Name'} dd={locality.name} />
                    <Definition dt={'Continent/Ocean'} dd={locality.cont_ocean} />
                    <Definition dt={'Country'} dd={locality.country} />
                    <Definition dt={'State'} dd={locality.state} />
                    <Definition dt={'County'} dd={locality.county} />
                    <Definition dt={'Island'} dd={locality.island} />
                    <Definition dt={'Water Body'} dd={locality.water_body} />
                    <Definition dt={'Formation'} dd={locality.formation} />
                    <Definition dt={'Age'} dd={locality.age} />
                </dl>
            </>
        )
    }
}

export default Locality
